import { Component, OnInit } from '@angular/core';

import { LinkedAccountService } from 'src/app/services/common/linked-account.service';


@Component({
  selector: 'app-linked-accounts',
  templateUrl: './linked-accounts.component.html',
  styleUrls: ['./linked-accounts.component.css']
})
export class LinkedAccountsComponent implements OnInit {
  linkedAccounts: Array<any>;
  filteredLinkedAccounts: Array<any>;
  loading: boolean = true;
  pageLoading: boolean = true;
  nameFilter: string = '';

  constructor(
    private linkedAccountService: LinkedAccountService
  ) { }

  ngOnInit(): void {
    this.loadLinkedAccounts();
  }

  applyNameFilter() {
    if(this.nameFilter){
      this.filteredLinkedAccounts = this.linkedAccounts.filter((linkedAccount) => {
        return linkedAccount.user_name.toLowerCase().indexOf(this.nameFilter.toLowerCase()) > -1;
      });
    }else{
      this.filteredLinkedAccounts = this.linkedAccounts;
    }
  }

  loadLinkedAccounts(): void {
    this.loading = true;
    this.nameFilter = '';
    this.linkedAccountService.index()
      .then(response_json => {
        this.linkedAccounts = response_json.linked_accounts;
        this.applyNameFilter();
        this.loading = false;
        this.pageLoading = false;
      })
  }
}
